module.exports = __webpack_public_path__ + "static/media/Arbeidsminne-introduction-WORDS.1740ff3a.mp3";